import { Link, useLocation } from "react-router-dom";
import { useEffect, useState, useMemo } from "react";
import Grdeskreturnrequest from "./VisareturnByGrdesk";
import VisaReturnbyfinance from "./visaReturnbyFinance";
import VisareturnbyOps from "./visareturnByOps";
import useServerPagination from "../../../../hooks/useServerPagination";
import PaginationControls from "../../../../components/SmartDataTable/PaginationControls";
import SearchFilter from "../../../../components/SmartDataTable/SearchFilter";
import { CgSpinner } from "react-icons/cg";



const titles = [
  "S.NO", "VRR REFERENCE NO", "VISA PROVIDER NAME", "VISA PROFESSION",
  "NATIONALITY", "VISA BLOCK NUMBER", "SPONSOR ID",
  "VISA RETURN REQUESTED QTY", "VISA RETURN APPROVED QTY", "STATUS",
];

const Dropdowndata = [
  { id: 1, name: "PENDING IN GR QUEUE" },
  { id: 2, name: "GR APPROVED" },
  { id: 3, name: "PENDING IN OPS1" },
  { id: 4, name: "OPS1 APPROVED" },
  { id: 5, name: "PAYMENT RECIEVED" },
  { id: 6, name: "GR REJECTED" },
];

const NAV_BASE = "p-2 px-4 rounded-md text-white text-sm font-medium";
const NAV_ACTIVE = { backgroundColor: "#1f2937" };
const NAV_INACTIVE = { backgroundColor: "#ef4444" };
const navLink = (isActive) => ({ className: NAV_BASE, style: isActive ? NAV_ACTIVE : NAV_INACTIVE });

export default function VisaReturn() {
  const location = useLocation();
  const token = useMemo(() => localStorage.getItem("nodeToken"), []);
  const [addOrEdit, setAddOrEdit] = useState({ routeName: "" });
  const [searchTerm, setSearchTerm] = useState("");
  const [filter, setFilter] = useState("");

  const { data, paginationState, goToPage, changePageSize } = useServerPagination({
    apiEndpoint: "/dashboard/vrr-visa",
    token,
    defaultPageSize: 50,
    searchTerm,
    searchDebounceMs: 300,
  });

  useEffect(() => {
    const segment = location.pathname.split("/")[3];
    if (segment === "Gr-desk") setAddOrEdit({ routeName: "grdesk" });
    else if (segment === "Finance-desk") setAddOrEdit({ routeName: "financedesk" });
    else if (segment === "Ops-desk") setAddOrEdit({ routeName: "opsdesk" });
    else setAddOrEdit({ routeName: "" });
  }, [location.pathname]);

  if (addOrEdit.routeName === "grdesk") return <Grdeskreturnrequest />;
  if (addOrEdit.routeName === "financedesk") return <VisaReturnbyfinance />;
  if (addOrEdit.routeName === "opsdesk") return <VisareturnbyOps />;

  const filteredData = filter ? data.filter((item) => item.status === filter) : data;

  return (
    <div className="p-2 uppercase">

      {/* Toolbar */}
      <div className="flex-wrap gap-2 w-full items-center flex flex-row-reverse mb-4">
        <SearchFilter
          searchTerm={searchTerm}
          onSearchChange={setSearchTerm}
          placeholder="Search across all columns..."
          isLoading={paginationState.isLoading && searchTerm.length > 0}
        />
        <select
          className="select select-sm select-bordered focus:outline-none cursor-pointer"
          onChange={(e) => setFilter(e.target.value === "select value" ? "" : e.target.value)}
        >
          <option value="select value">All Status</option>
          {Dropdowndata.map((d) => <option key={d.id} value={d.name}>{d.name}</option>)}
        </select>
        <Link to="/dashboard/Visa-return-request/Finance-desk" {...navLink(location.pathname.includes("Finance-desk"))}>FINANCE DESK</Link>
        <Link to="/dashboard/Visa-return-request/Gr-desk" {...navLink(location.pathname.includes("Gr-desk"))}>GR DESK</Link>
        <Link to="/dashboard/Visa-return-request/Ops-desk" {...navLink(location.pathname.includes("Ops-desk"))}>OPS 1 DESK</Link>
      </div>

      {/* Scrollable Table */}
      <div className="overflow-x-auto bg-white rounded-lg shadow max-h-[70vh]">
        <table className="min-w-full">
          <thead className="sticky top-0 z-20 bg-white border-b border-slate-200">
            <tr>
              {titles.map((t, i) => (
                <th key={i} className="px-6 py-4 text-left text-base font-semibold text-gray-700 uppercase tracking-wider">
                  {t}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white">
            {paginationState.isLoading ? (
              <tr>
                <td colSpan={titles.length} className="px-6 py-8 text-center">
                  <div className="flex items-center justify-center gap-2">
                    <CgSpinner className="animate-spin text-xl text-blue-500" />
                    <span>Loading data...</span>
                  </div>
                </td>
              </tr>
            ) : filteredData.length === 0 ? (
              <tr>
                <td colSpan={titles.length} className="px-6 py-8 text-center text-gray-400">
                  {searchTerm ? `No results found for "${searchTerm}"` : "No Data Found"}
                </td>
              </tr>
            ) : (
              filteredData.map((listItem, index) => (
                <tr key={listItem.id || index} className="hover:bg-gray-50">
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700">{(paginationState.currentPage - 1) * paginationState.pageSize + index + 1}</td>
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700">{listItem?.vrr_reference_number ?? "-----"}</td>
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700">{listItem?.visa_provider_name}</td>
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700">{listItem?.visa_profession}</td>
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700">{listItem?.Nationality}</td>
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700">{listItem?.visa_block_number}</td>
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700">{listItem?.sponsor_id}</td>
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700">{listItem?.visa_return_approval_qty ?? listItem?.visa_return_requested_qty}</td>
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700">{listItem?.visa_return_approval_qty}</td>
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700">{listItem?.status}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Footer */}
      <div className="mt-2">
        <PaginationControls
          currentPage={paginationState.currentPage}
          totalPages={paginationState.totalPages}
          pageSize={paginationState.pageSize}
          totalRecords={paginationState.totalRecords}
          onPageChange={goToPage}
          onPageSizeChange={changePageSize}
          isLoading={paginationState.isLoading}
        />
      </div>
    </div>
  );
}
